import * as React from 'react';
import { useBooleanState } from 'owa-react-hooks/lib/useBooleanState';
import { usePatchPartialPayload } from 'owa-timestream-asset-sdk';
import type { BucketPayload } from 'owa-timestream-asset-sdk-bucket';
import { getCharmForId, CharmInfo, lazyLoadCharmsCatalog } from 'owa-calendar-charms-store';
import useCharmColorScheme from './useCharmColorScheme';

let initializeCharms = false;

export default function useBucketViewCharmPickerState(charmId: number, color?: string) {
    // we only want to initialize charms if we have a bucket being used, so the lazy load is called here
    // rather than timestream boot. But only want it called once to avoid unnecessary reregisters
    if (!initializeCharms) {
        lazyLoadCharmsCatalog.importAndExecute();
        initializeCharms = true;
    }

    const charmPickerRef = React.useRef<HTMLDivElement | null>(null);
    const [isPickingCharm, setIsPickingCharm, setNotPickingCharm] = useBooleanState(false);
    const selectedCharm = React.useMemo(() => getCharmForId(charmId), [charmId]);

    const patchPartialPayload = usePatchPartialPayload<BucketPayload>();
    const onSelectIcon = React.useCallback(
        ({ IconId: charmId }: CharmInfo) => {
            patchPartialPayload({ charmId });
            charmPickerRef.current?.focus();
        },
        [patchPartialPayload, charmPickerRef.current]
    );

    const colorScheme = useCharmColorScheme(color);

    return {
        isPickingCharm,
        charmPickerProps: {
            ref: charmPickerRef,
            selectedCharm,
            onSelectIcon,
            colorScheme,
            onClick: setIsPickingCharm,
            onAfterMenuDismiss: setNotPickingCharm,
        },
    };
}
